import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Image1 from '../assets/home/green-orchid-villas.jpg';
import Image2 from '../assets/home/sandalwood.png';
import Image3 from '../assets/home/urban-heights.jpg';
import subham from '../assets/home/subham.jpg';
import maha from '../assets/maha.png';
import vajram from '../assets/pdfs/brochure.pdf';
import vajramImg from '../assets/home/Vajram.jpg';
import satyaelite from '../assets/satyaelite.png'
const OnGoingProjects = () => {
  // State to manage the specific PDF being viewed
  const [selectedPdf, setSelectedPdf] = useState(null);

  const plotProjects = [
    {
      title: "Satya's Elite",
      description: "Fertile farming land with ideal climate, irrigation, and easy access for diverse crop cultivation.",
      image: satyaelite,
      location: "Kurumaddali Village ,Pamuru Mandal ,Krishna District.",
      plots: 150,
      totalSqFeet: "30 acres",
      year: 2026,
      pdf: vajram,
    },
    // {
    //   title: "Vajram",
    //   description: "A prime location expansion with plots suitable for mixed-use development.",
    //   image: vajramImg,
    //   location: "Tadikonda",
    //   plots: 75,
    //   totalSqFeet: "15",
    //   year: 2024,
    //   pdf: vajram,
    // },
    {
      title: "Subham Avenues",
      description: "A fully developed land area with a focus on residential plots and community spaces.",
      image: subham,
      location: "pamuru",
      plots: 120,
      totalSqFeet: "32",
      year: 2025,
      pdf: vajram,
    },
    {
      title: "MAHALAKSHMI'S GOLDEN CITY",
      description: "A Premium Residential Venture by KVR Developers. Invest in KVR… Secure a Bright Future for Your Generations!",
      image: maha,
      location: "Chilakaluripeta",
      plots: 90,
      totalSqFeet: "14",
      year: 2025,
      pdf: vajram,
    },
  ];

  // Helper to close modal
  const closeModal = () => setSelectedPdf(null);

  return (
    <section id="upcoming-plot-projects" className="bg-gray-50 py-16 lg:py-24 relative">
      <div className="container mx-auto px-4 lg:px-8">

        {/* Animated Header Text */}
        <motion.h2
          className="text-4xl lg:text-4xl font-extrabold text-gray-800 mb-12 text-center"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          Ongoing Projects
        </motion.h2>

        {/* Grid of Plot Projects */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {plotProjects.map((project, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-lg shadow-lg flex flex-col"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-72 object-cover rounded-t-lg mb-4"
              />
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                {project.title}
              </h3>
              <p className="text-gray-600 mb-4 flex-grow">{project.description}</p>

              <div className="text-gray-700 mb-6">
                <p><strong>Location:</strong> {project.location}</p>
                <p><strong>Total Acres:</strong> {project.totalSqFeet}</p>
                <p><strong>Year:</strong> {project.year}</p>
              </div>

              {/* View Brochure Button */}
              {/* <button
                onClick={() => setSelectedPdf(project.pdf)}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded transition duration-300 ease-in-out"
              >
                View Brochure
              </button> */}
            </motion.div>
          ))}
        </div>
      </div>

      {/* PDF Modal using AnimatePresence for smooth entry/exit */}
      <AnimatePresence>
        {selectedPdf && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeModal} // Close when clicking background
          >
            <motion.div
              className="bg-white rounded-lg shadow-2xl w-full max-w-4xl h-[80vh] relative flex flex-col"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              onClick={(e) => e.stopPropagation()} // Prevent closing when clicking content
            >
              {/* Modal Header */}
              <div className="flex justify-between items-center p-4 border-b">
                <h3 className="text-lg font-bold text-gray-800">Project Brochure</h3>
                <button
                  onClick={closeModal}
                  className="text-gray-500 hover:text-red-500 transition-colors"
                >
                  {/* Standard SVG Close Icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* PDF Viewer (Iframe) */}
              <div className="flex-grow bg-gray-100 p-1">
                <iframe
                  src={selectedPdf}
                  title="PDF Viewer"
                  className="w-full h-full rounded"
                  style={{ border: 'none' }}
                />
              </div>

              {/* Mobile Fallback Link */}
              <div className="p-2 text-center text-sm text-gray-500 md:hidden block">
                <a href={selectedPdf} target="_blank" rel="noopener noreferrer" className="underline text-blue-600">
                  Click here if PDF doesn't load
                </a>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default OnGoingProjects;